<template>

    <div class="page-container">
        <div class="d-flex justify-content-between">
            <router-link class="back-route h3" ref="backBtn" @click="backHandler"
                         :to="((isFull ||isData) ? '#':'/settings/entities')">
                <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                Create Entity
            </router-link>
            <SaveBtn @save="submitHandler"/>
        </div>


        <div id="createEntityContainer" class="tabcontent my-3">

            <div class="err" v-if="orgError.length > 0">
                <div v-for="msg in orgError" class="text-danger">{{msg}}</div>
            </div>

            <div class="entity-section row m-0 d-flex justify-content-between my-3" v-for="(item, index) in items"
                 :key="index">
                <div class="col-lg-5 col-md-4 col-sm-5 entity-input-container">
                    <label>Entity Name <span style="color: #E95626">*</span></label>
                    <input class="custom-input form-control" type="text"
                           autocomplete="off"
                           @input="changeHandler($event,index)"
                           v-model="item.name" name="entityName"/>

                    <div class="err" v-if="item.errors['name'].length > 0">
                        <div v-for="msg in item.errors['name']" class="text-danger">{{msg}}</div>
                    </div>
                </div>

                <div class="col-lg-5 col-md-4 col-sm-5 entity-input-container">

                    <label>Assign to <span style="color: #E95626">*</span></label>
                    <Multiselect
                            :key="index"
                            v-model="item.parent_id"
                            :options="item.options"
                            :ref="item.ref"
                            class="multiselect-style scrollbar"
                            @click="selectHandler($event, index)"
                    />

                    <div class="err" v-if="item.errors['parent'].length > 0">
                        <div v-for="msg in item.errors['parent']" class="text-danger">{{msg}}</div>
                    </div>
                </div>

                <div class="col-lg-1 col-md-1 col-sm-1 align-self-center">
                    <div @click="deleteHandler(index)" :class="!item.delateFlag ? 'd-none' : 'd-block'">
                     <span class="delete-icon">
                         <font-awesome-icon :icon="['fas', 'times']" size="sm"/>
                     </span>
                    </div>
                </div>

            </div>
            <div class="my-2 add-section" @click="addHandler">
           <span class="add-icon">
                <font-awesome-icon :icon="['fas', 'plus']" size="sm"/>
            </span>
                <span class="add-text">
                Add Another Entity
            </span>
            </div>

        </div>
    </div>


    <AlartModal v-if="showModal" message="Entity Created Successfully" imagePath="okImage.svg"
                @close-modal="showModal = false"/>
    <AlartModal v-if="showErrorModal" :message="responseErrorMessage" imagePath="close.png"
                @close-modal="showErrorModal = false"/>

    <ConfirmationModal v-if="isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>


</template>
<script>
    import SaveBtn from '../../components/SaveBtn';
    import {computed, defineAsyncComponent} from "vue";

    import repository from "../../../api-services/repository";


    import Multiselect from '@vueform/multiselect';
    import router from "../../../router";
    import {logger} from "../../../helpers/logger";

    const ConfirmationModal = defineAsyncComponent(() =>
        import ('../../components/ConfirmationModal')
    );
    const AlartModal = defineAsyncComponent(() =>
        import ('../../components/AlartModal')
    );


    export default {
        name: 'setting-entity-create',

        components: {SaveBtn, AlartModal, ConfirmationModal, Multiselect},

        data() {

            return {
                isData: computed(() => this.$store.state.settings.setDataFlag),
                confirmModal: computed(() => this.$store.state.settings.confirmModal),
                confirmMessage: computed(() => this.$store.state.settings.confirmMessage),
                showModal: false,
                showErrorModal: false,
                isFull: false,
                isError: false,
                responseErrorMessage: '',
                orgError: [],
                entities: [],
                entitiesOriginalLength: 0,
                name: '',
                parent_id: null,
                options: [],
                items: [
                    {
                        name: '',
                        parent_id: null,
                        level: {},
                        parent: {},
                        options: [],
                        ref: '',
                        delateFlag: false,
                        errors: {
                            name: [],
                            parent: []
                        }
                    }
                ],
            }


        },
        async mounted() {
            await this.$store.dispatch('activeTap', 'settings-entities');
            await this.getEntities();
        },

        methods: {
            async getEntities() {
                let entitiesData = await repository.index('entities', false, 'asc', false);
                this.entities = entitiesData.data.data;
                if (process.env.VUE_ENV === 'development')
                    console.log({entitiesData})

                this.options.push({
                    value: "null",
                    label: "parent"
                });

                this.items[0].options.push({
                    value: "null",
                    label: "parent"
                });


                this.entities.forEach((item) => {
                    this.options.push({
                        value: item.id,
                        label: item.name
                    });

                    this.items[0].options.push({
                        value: item.id,
                        label: item.name
                    });
                })

                this.items[0].ref = 'ref-0';
                this.entitiesOriginalLength = this.entities.length;
                this.entities.forEach((e, idx) => {
                    this.items[0]['parent'][`option${e.id}`] = {label: e.name, value: e.id, level: e.level};
                    this.items[0]['level'][`${e.id}`] = e.level;
                });
            },

            selectHandler(e, index) {


                let perentLevel = this.items[index]['parent_id'] !== null ? this.items[index]['parent_id'] !== "null" ? this.items[index]['parent'][`option${this.items[index]['parent_id']}`]['level'] : 0 : 0;
                let newChildLevel = (perentLevel ? perentLevel : 0) + 1;


                if (this.items[index]['parent_id'] !== null) {
                    this.items[index].errors['parent'] = []
                }

                if (perentLevel !== undefined && newChildLevel <= `${process.env.VUE_APP_TREE_PATH}`) {
                    let entitiesLength = this.entitiesOriginalLength;
                    let editIndex = entitiesLength + index;
                    let enteredValue = e.target.value;
                    this.entities[editIndex] = {...this.entities[editIndex], level: newChildLevel};
                    this.items[index].errors['parent'] = []
                } else {
                    this.items[index].errors['parent'] = ['* Tree is full']
                }
            },

            async resetView() {
                this.options = [];
                this.items = [
                    {
                        name: '',
                        parent_id: null,
                        level: {},
                        parent: {},
                        options: [],
                        ref: '',
                        delateFlag: false,
                        errors: {
                            name: [],
                            parent: []
                        }
                    }
                ];
                await this.$store.dispatch('setDataFlag', false);
                await this.getEntities();
            },

            async changeHandler(e, index) {


                let entitiesLength = this.entitiesOriginalLength;
                let editIndex = entitiesLength + index;
                let enteredValue = e.target.value;

                logger(["editIndex ", editIndex])
                if (enteredValue.length < 1) {
                    this.items[index].errors['name'] = ['*Required'];

                } else if (enteredValue.length > 40) {
                    this.items[index].errors['name'] = ['* Name is too long'];
                } else {
                    this.entities[editIndex] = {
                        uId: this.entities[editIndex]?.uId,
                        id: e.target.value,
                        name: e.target.value,
                        level: this.entities[editIndex]?.level ? this.entities[editIndex]['level'] : 0
                    };
                    this.items[index].errors['name'] = []
                }
                await this.checkData();
            },

            async submitHandler() {
                const error = await this.checkData();
                // console.log({error})
                if (!error) {
                    try {
                        await this.$store.dispatch('setDataFlag', false);
                        const cretedEntities = await repository.create('entities', {data: this.items});
                        this.showModal = true;
                        await this.resetView();
                        setTimeout(() => {
                            this.$router.push({name: 'entities'});
                        }, 1000);
                    } catch (e) {
                        this.showErrorModal = true;
                        this.responseErrorMessage = e.response.data.message
                        for (const property in e.response.data.errors) {
                            let key = property.split('.')[2];
                            let record = property.split('.')[1]
                            if (key === 'organization_id') {
                                this.orgError = ['* Organization not found']
                            } else {
                                this.items[record].errors[key].push(`* ${e.response.data.errors[property]}`)
                            }
                        }
                    }
                } else {
                    await this.$store.dispatch('setDataFlag', true);
                }


            },

            async backHandler() {
                let BreakException = {};
                let setDataFlag = false;
                try {
                    this.items.forEach((item) => {
                        if (item.name !== '') {
                            setDataFlag = true;
                            throw BreakException;
                        }
                    })
                } catch (e) {
                    if (e !== BreakException) throw e;
                }
                if (setDataFlag) {
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                } else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },

            addHandler() {
                let entitiesLength = this.entities.length;
                let itemsLength = this.items.length;
                let newIndex = 0;
                let options = {};

                let entityName = this.items[itemsLength - 1]['name'];
                let entityParent = this.items[itemsLength - 1]['parent_id'];
                this.isError = false

                if (entityName.length < 1) {
                    this.items[itemsLength - 1]['errors']['name'] = ['*Required']
                    this.isError = true
                }
                if (entityParent === null) {
                    this.items[itemsLength - 1]['errors']['parent'] = ['*Required']
                    this.isError = true
                }

                if (!this.isError) {
                    let uId = new Date().getTime();
                    this.options = [{
                        id: uId,
                        value: "null",
                        label: "parent"
                    }];
                    this.entities.forEach((e, idx) => {
                        if (e.id !== 'new') {
                            options[`option${e.id}`] = {}
                            options[`option${e.id}`] = {label: e.name, value: e.id, level: e.level}
                            this.options.push(
                                { id: e.uId,label: e.name, value: e.id}
                            )
                        }

                    });


                    this.items.push({
                        id: uId,
                        name: '',
                        parent_id: null,
                        level: {},
                        parent: options,
                        options: this.options,
                        ref: `ref-${itemsLength}`,
                        delateFlag: true,
                        errors: {
                            name: [],
                            parent: []
                        }
                    })

                    itemsLength = this.items.length;
                    newIndex = entitiesLength + (itemsLength - 1);

                    logger(["newIndex ", newIndex])
                    // this.entities[newIndex] = {id: 'new', name: '', uId: uId};
                    this.entities.push({id: 'new', name: '', uId: uId});
                }

                logger(["entities => ",this.entities])

            },

            deleteHandler(index) {
                console.log({index}, this.entities[index], this.entities.length)
                let entitiesLength = this.entities.length;
                let removeIndex = entitiesLength + index;
                let deletedItemId = this.items[index]['id'];

                this.items.forEach((item) => {
                    item.options.forEach((opt, idx) => {
                        if(opt.id === deletedItemId){
                            if(item.parent_id === this.items[index]['name']){
                                item.parent_id = 'null';
                            }
                            item.options.splice(idx, 1);
                        }
                    })
                })

                logger(["index => ",index], ["entities | length => ",this.entities.length],
                    ["items => ", this.items])
                this.items.splice(index, 1);
                this.entities.splice(removeIndex, 1);
            },

            async confirmModalHandler(e) {
                this.isFull = false;
                await this.$store.dispatch('setConfirmModal', false);
                if (e) {
                    await this.$store.dispatch('setDataFlag', false);
                    await this.$router.push('/' + this.$store.state.settings.currentRoute);
                }
            },

            checkData() {
                let isError = false;
                this.items.forEach(async (item) => {
                    if (item.name.length < 1) {
                        item.errors['name'] = ['*Required'];
                        isError = true;
                    } else if (item.name.length < 2) {
                        item.errors['name'] = ['* Entity name must be more than 2 characters'];
                        isError = true;
                    } else if (item.name.length > 40) {
                        item.errors['name'] = ['* Entity name must be less than 40 characters'];
                        isError = true;
                    } else {
                        item.errors['name'] = [];
                    }

                    if (item.parent_id === null) {
                        item.errors['parent'] = ['*Required'];
                        isError = true;
                    } else if (item.errors['parent'].length > 0) {
                        isError = true;
                    } else {
                        item.errors['parent'] = [];
                    }
                });
                return isError;
            }
        }
    }
</script>
<style scoped>

    .multiselect-style {
        background-color: transparent;
        color: var(--main-color);
        border: 1px solid #04445E;
        height: 50px;
        width: 310px;
    }

    #createEntityContainer {
        padding: 20px;
        height: 77vh;
        overflow-y: auto;
    }


    .custom-input,
    .custom-input:focus {
        width: 250px;
        height: 50px;
        background-color: transparent;
        border: 1px solid #04445E;
        border-radius: 6px;
        color: var(--main-color);
        outline: 0;
        box-shadow: 0 0 0 0;
    }


    .entity-section {
        height: 150px;
        align-items: center;
        border: 1px solid #39525C;
        padding: 20px 10px;
    }

    .entity-input-container {
        height: 75px;
    }

    .add-icon {
        display: inline-block;
        border-radius: 50%;
        width: 22px;
        height: 22px;

        text-align: center;
        align-items: center;
        align-content: center;
        background-color: transparent;
        color: var(--main-color);
        border: 1px solid var(--border-color-profile-icon);
        /*background-image: linear-gradient(to bottom, #044d6b, #044560, #043d54, #04354a, #042d3f);*/
        font-size: 13px;
    }

    .add-text {
        font-size: 11px;
    }

    .add-section {
        cursor: pointer;
        width: 130px;
    }

    .err {
        overflow-y: auto;
        max-height: 170px;
        min-height: 10px;
    }

    .custom-input {
        background-color: transparent;
        color: var(--main-color);
    }


    .delete-icon {
        display: inline-block;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        text-align: center;
        align-items: center;
        align-content: center;
        background-color: transparent;
        font-size: 16px;
        color: var(--main-color);
        border: 1px solid var(--border-color-profile-icon);
        cursor: pointer;
    }
</style>

